import { useState, view } from '@esui/core';
import { Grid } from '@esui/core/layout/index.js';
import { css } from 'lit';
import { DemoPage, Title } from '../@demo/utils.js';
import { Button } from '../button/index.js';
import { LinearProgress } from './index.js';

export const [LinearProgressDemo] = view('linear-progress-demo', {
  template() {
    const [progressClosed, setProgressClosed] = useState(false);

    return DemoPage(
      Grid(
        Button('Toggle')
          .raised()
          .onClick(() => setProgressClosed(closed => !closed))
          .gridItem({ justifySelf: 'start' }),

        LinearProgress().closed(progressClosed),

        Title('linear-progress: reverse'),
        LinearProgress(0.4).reverse().className('demo-progress-bar'),

        Title('liner-progress: determinate'),
        LinearProgress(0.5).buffer(1),

        Title('liner-progress: determinate buffer'),
        LinearProgress(0.3).buffer(0.7).className('demo-progress-bar'),

        Title('liner-progress: determinate buffer reverse'),
        LinearProgress(0.2).buffer(0.6).reverse().className('demo-progress-bar')
      )
        .templateColumns('max-content minmax(30vw, 50rem)')
        .gridGap('2rem')
        .alignItems('end')
    );
  },

  cssTemplate: css`
    .demo-progress-bar {
      --mdc-theme-primary: red;
      --mdc-linear-progress-buffer-color: orange;
      --mdc-linear-progress-buffering-dots-image: url("data:image/svg+xml,%3Csvg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' enable-background='new 0 0 5 2' xml:space='preserve' viewBox='0 0 5 2' preserveAspectRatio='none slice'%3E%3Ccircle cx='1' cy='1' r='1' fill='%23ffcdd2'/%3E%3C/svg%3E");
    }
  `,
});
